<template>
  <div class="actions-menu-wrapper" data-app>
    <BbMenu
      v-model="showMenu"
      class="actions-menu"
      display-items="6"
      max-width="240px"
      min-width="240px"
      nudge-bottom="8"
      size="medium"
      is-offset-y
      alignment="bottom-left"
    >
      <template #menuActivator>
        <BbBtn
          :class="['open-actions-menu-button', { active: showMenu }]"
          size="x-small"
          type="icon"
          icon="menu-dots"
          icon-size="medium"
          icon-type="filled"
          no-background
        ></BbBtn>
      </template>

      <BbMenuItem
        v-for="(item, index) in items"
        :key="`action-item-${index}`"
        class="action-item"
        size="medium"
        @click="handleMenuItemClick(item.name)"
      >
        <TextBody :i18n-key="item.label"></TextBody>
      </BbMenuItem>
    </BbMenu>
    <WarningPopup
      :popup-opened="confirmDeletePopupOpened"
      title-key="common.delete"
      warning-message-key="modals.warningDeleteMessage"
      confirm-text-key="modals.confirmDeleteText"
      @update:open="confirmDeletePopupOpened = false"
      @execute:action="confirmDelete"
    />
  </div>
</template>

<script>
import { ref } from 'vue';

import { ACTIONS_MENU } from '~/constants/documentActions';

import TextBody from '~/components/common/TextBody';
import WarningPopup from '~/components/common/WarningPopup';

export default {
  name: 'ActionsMenu',
  components: { TextBody, WarningPopup },
  props: {
    id: {
      type: String,
      default: '',
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    actionsMenuItems: {
      type: Array,
      default: () => ACTIONS_MENU,
    },
  },
  emits: ['remove', 'edit'],
  setup(props, { emit }) {
    const showMenu = ref(false);

    const items = props.isEditMode
      ? props.actionsMenuItems
      : props.actionsMenuItems.filter((action) => action.name !== 'edit');
    const confirmDeletePopupOpened = ref(false);

    const confirmDelete = async () => {
      confirmDeletePopupOpened.value = false;
      emit('remove', props.id);
    };

    const handleMenuItemClick = async (action) => {
      switch (action) {
        case 'edit': {
          emit('edit');
          break;
        }
        case 'share': {
          console.log('will be implemented');
          break;
        }
        case 'delete': {
          confirmDeletePopupOpened.value = true;
          break;
        }
        case 'download': {
          emit('download', props.id);
          break;
        }
        default: {
          console.log('unknown action');
        }
      }
    };
    return {
      confirmDelete,
      confirmDeletePopupOpened,
      items,
      handleMenuItemClick,
      showMenu,
    };
  },
};
</script>

<style scoped lang="scss">
.actions-menu-wrapper {
  .action-item {
    color: $bb-primary-1 !important;
  }
}
</style>
